import type VueRouter from 'vue-router'

import { API } from '@/api/API'
import { authExternal } from '@/helpers/AuthExternal'
import store from '@/store/store'

export async function logout(router?: VueRouter, nextPath?: string) {
  if (authExternal.isExternalAuth()) {
    return authExternal.logout(nextPath ?? window.location.pathname)
  }

  await API.post('logout')
  await store.dispatch('clearAll')

  if (router && nextPath) router.push(nextPath)
}

export function ensureLoggedOut() {
  return isLoggedIn() ? logout() : Promise.resolve()
}

export function isLoggedIn(): boolean {
  return Boolean(store.getters['Member/user'])
}
